import type { PivotDateGroupEnum } from '@ztechapps/common.contract'
import { PIVOT_DAY_PART_LABEL } from './constants'

/** Label of a date field's part — a field with no stored grouping is its Day part. */
export const toPivotDatePartLabel = (field: string, dateGroup?: PivotDateGroupEnum): string =>
  `${field}.${dateGroup ?? PIVOT_DAY_PART_LABEL}`
